import { Component, OnInit } from '@angular/core';
import { User } from './models/User';
import { AccountService } from './services/account.service';
declare var jQuery: any;
declare var $: any;
declare var window : any;
window.$ = window.jQuery = $;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'webcatalogacion';

  ngOnInit() {



    (function ($) {
      //  "use strict";





    })(jQuery);
  }
}
